
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6abf4e1e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Articles.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Articles.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6abf4e1e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Articles.vue"),
  /* scopeId */
  "data-v-6abf4e1e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Article/Articles.vue
// module id = 577
// module chunks = 0